module.exports = __webpack_public_path__ + "img/qgb_mac.a4a9b5ab.png";